import type { FetchQueryOptions } from "@tanstack/react-query";
import { queryClient } from "lib/react-query";

export const cacheFirstFetch = <T = unknown>(
  queryOptions: FetchQueryOptions<any>,
): T | Promise<T> => {
  const key = queryOptions.queryKey;

  const data = queryClient.getQueryData(key);

  if (data) return data as T;
  return queryClient.fetchQuery(queryOptions);
};
